export const ROUTES = {
  AUTH: "/",

  // Admin Routes
  ADMIN_HOME: "/admin",
  ADMIN_USERS: "/admin/users",
  ADMIN_USER_MANAGE: "/admin/user/manage",
  ADMIN_ZONE_LIST: "/admin/zones",
  ADMIN_ZONE_ADD: "/admin/zones/add",
  ADMIN_ZONE_EDIT: "/admin/zones/edit",
  ADMIN_ZONE_ITEMS: "/admin/zones/items",
  ADMIN_ZONE_ITEMS_CREATE: "/admin/zones/items/create",
  ADMIN_ZONE_ITEMS_UPDATE: "/admin/zones/items/update",
  ADMIN_AWARDS: "/admin/awards",
  ADMIN_CLIENTS: "/admin/clients",

  // Calculator Routes
  CAL_LIST: "/cal/list",
  CAL_DATA_SHEET: "/cal/data-sheet",

  // Cal Wizard
  CAL_MANAGE_CUSTOMER_DATA_CREATE: "/cal/manage/customer-data/create",
  CAL_MANAGE_CUSTOMER_DATA: "/cal/manage/customer-data",
  CAL_MANAGE_TOUR_PLAN: "/cal/manage/tour-plan",
  CAL_MANAGE_ADDRESS_DATA: "/cal/manage/address-plan",
  CAL_MANAGE_ITEM_LIST: "/cal/manage/item-list",
  CAL_MANAGE_LOGISTIC_DATA: "/cal/manage/logistic-data",
  CAL_MANAGE_SUMMARY: "/cal/manage/summary",
};
